/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "../src/helpers/mobxConfig";
import Honeybadger from "@honeybadger-io/js";
import { logDevtoolsGreeting } from "../src/helpers/devtoolsGreeting";
import { initializeScroll } from "../src/helpers/scroll";
import { scrollMe } from "../src/helpers/scrollme";
/* eslint-disable */

const honeybadger = Honeybadger.configure({
  apiKey: process.env.HONEYBADGER_API_KEY,
  environment: process.env.NODE_ENV,
});

document.addEventListener("DOMContentLoaded", () => {
  logDevtoolsGreeting();

  // The app itself is mounted by react_ujs from react_component("App") in
  // layouts/react.html.slim, which resolves to components/App.js. This file
  // used to *also* render a second App from src/App.tsx into a div appended
  // here -- but that copy's render() returned an empty <div />, so every page
  // built a component tree that drew nothing and appended a stray element for
  // it to not draw into. Removed along with src/App.tsx.
  initializeScroll();
  scrollMe();
  window.honeybadger = honeybadger;
});

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
